<app-header></app-header>
<app-sidebar></app-sidebar>
<app-right-sidebar></app-right-sidebar>
<div dir="ltr">
    <router-outlet></router-outlet>
</div>
